var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHjem = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.677,5.46,15.4.116a.735.735,0,0,0-.794,0L6.323,5.46A.7.7,0,0,0,6,6.047V17.3a.712.712,0,0,0,.72.7H23.28a.712.712,0,0,0,.72-.7V6.047A.7.7,0,0,0,23.677,5.46ZM16.44,18H13.56V12.375h2.88Z",
    transform: "translate(-6 0)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHjem, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hjem.053e0d04.svg";
export { ForwardRef as ReactComponent };